module.exports = __webpack_public_path__ + "media/images/btn_station_return-c190e4745014b9096b5921097aaaa1f6.gif";